import {eventBus} from "../main";
import moment from "moment";

export let notificationComponentMixin = {
    data() {
        return {
            notificationCreatedTime: undefined
        }
    },
    beforeMount() {
        this.notificationCreatedTime = moment().format('HH:mm');
    },
    methods: {
        translate(key) {
            return this.$t(key);
        },
        translateWithValue(key, value) {
            return this.$t(key, value)
        },
        openProfileDialog(userData) {
            eventBus.emit('open-profile-dialog', {
                user: userData,
            });
        },
    }
}
